/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDayAvailability200ResponseValueInner } from './GetDayAvailability200ResponseValueInner';
import {
    GetDayAvailability200ResponseValueInnerFromJSON,
    GetDayAvailability200ResponseValueInnerFromJSONTyped,
    GetDayAvailability200ResponseValueInnerToJSON,
    GetDayAvailability200ResponseValueInnerToJSONTyped,
} from './GetDayAvailability200ResponseValueInner';

/**
 * 
 * @export
 * @interface CreatePromotionRequestSchedule
 */
export interface CreatePromotionRequestSchedule {
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    monday: Array<GetDayAvailability200ResponseValueInner>;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    tuesday: Array<GetDayAvailability200ResponseValueInner>;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    wednesday: Array<GetDayAvailability200ResponseValueInner>;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    thursday: Array<GetDayAvailability200ResponseValueInner>;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    friday: Array<GetDayAvailability200ResponseValueInner>;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    saturday: Array<GetDayAvailability200ResponseValueInner>;
    /**
     * 
     * @type {Array<GetDayAvailability200ResponseValueInner>}
     * @memberof CreatePromotionRequestSchedule
     */
    sunday: Array<GetDayAvailability200ResponseValueInner>;
}

/**
 * Check if a given object implements the CreatePromotionRequestSchedule interface.
 */
export function instanceOfCreatePromotionRequestSchedule(value: object): value is CreatePromotionRequestSchedule {
    if (!('monday' in value) || value['monday'] === undefined) return false;
    if (!('tuesday' in value) || value['tuesday'] === undefined) return false;
    if (!('wednesday' in value) || value['wednesday'] === undefined) return false;
    if (!('thursday' in value) || value['thursday'] === undefined) return false;
    if (!('friday' in value) || value['friday'] === undefined) return false;
    if (!('saturday' in value) || value['saturday'] === undefined) return false;
    if (!('sunday' in value) || value['sunday'] === undefined) return false;
    return true;
}

export function CreatePromotionRequestScheduleFromJSON(json: any): CreatePromotionRequestSchedule {
    return CreatePromotionRequestScheduleFromJSONTyped(json, false);
}

export function CreatePromotionRequestScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePromotionRequestSchedule {
    if (json == null) {
        return json;
    }
    return {
        
        'monday': ((json['monday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
        'tuesday': ((json['tuesday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
        'wednesday': ((json['wednesday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
        'thursday': ((json['thursday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
        'friday': ((json['friday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
        'saturday': ((json['saturday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
        'sunday': ((json['sunday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerFromJSON)),
    };
}

export function CreatePromotionRequestScheduleToJSON(json: any): CreatePromotionRequestSchedule {
    return CreatePromotionRequestScheduleToJSONTyped(json, false);
}

export function CreatePromotionRequestScheduleToJSONTyped(value?: CreatePromotionRequestSchedule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monday': ((value['monday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
        'tuesday': ((value['tuesday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
        'wednesday': ((value['wednesday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
        'thursday': ((value['thursday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
        'friday': ((value['friday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
        'saturday': ((value['saturday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
        'sunday': ((value['sunday'] as Array<any>).map(GetDayAvailability200ResponseValueInnerToJSON)),
    };
}

